import React from "react";
import {
  AttenCallHoc,
  RejectCallHoc,
  BackToChatHoc,
} from "../../assets/images";
import WebChatProfileImg from "../WebChat/Profile/WebChatProfileImg";
import { capitalizeFirstLetter } from "../../Helpers/Utility";
import {
  DISCONNECTED_SCREEN_DURATION,
  CALL_STATUS_DISCONNECTED,
  COMMON_ERROR_MESSAGE,
  PERMISSION_DENIED,
  CALL_SESSION_STATUS_CLOSED,
} from "../../Helpers/Call/Constant";
import {
  clearMissedCallNotificationTimer,
  dispatchDisconnected,
  getCallDisplayDetailsForOnetoManyCall,
} from "../../Helpers/Call/Call";
import Logo from "../../assets/images/new-images/logoNew.png";
import { getGroupData } from "../../Helpers/Chat/Group";
import { getUserDetails } from "../../Helpers/Chat/User";
import { toast } from "react-toastify";
import CallerProfileList from "./CallerProfileList";
import {
  deleteItemFromLocalStorage,
  encryptAndStoreInLocalStorage,
} from "../../Helpers/Chat/webChatEncryptDecrypt";
import { useSelector } from "react-redux";
import SDK from "../../SDK";
import { addShowConfrenceData } from "../../Redux/feature/showConfrenceDataSlice";
import { store } from "../../Redux/store";
import { resetCallData } from "../../callback";
import { showModal } from "../../Redux/feature/popUpDataSlice";
import callLogs from "./CallLogs/callLog";
import { isUserWhoBlockedMe } from "../../Helpers/Chat/BlockContact";

let callingTimer;
const CalleScreen = (props = {}) => { 
  const { hideCallScreen,endCallAction = ()=> {} } = props;
  let audio = window.ringingTone
  let preventMultipleClick = false;
  audio.autoplay = true;
  audio.muted = true;
  let rosterDatalocal = {};
  let isGroupCall = false;
  let callConnectionData = "";
  let callType = "";
  const callConnectionDate = useSelector((state) => state.callConnectionDate);
  const rosterData = useSelector((state) => state.rosterData);
  const addCustomCall = useSelector((state) => state.addCustomCall.data);
  const handleTernayAvoid = (isGroupCalle = false, calleType = "") => {
    if (props.callStatus === CALL_STATUS_DISCONNECTED.toLowerCase()) {
      return capitalizeFirstLetter(props.callStatus);
    }
    return `Incoming ${isGroupCalle ? "Group" : ""} ${calleType} Call...`;
  };
  
  React.useEffect(() => {
    store.dispatch(showModal({
        open:false,
        modelType:'callparticipants'
    }))

    document.querySelectorAll("audio").forEach((element) => {
      element.pause();
    });
    // document.body.addEventListener("mousemove", function () {})
    handleIncomingCallAudio();
    callingTimer = setTimeout(() => {
      endCall();
    }, 30000);
    return () => {
      stopAudio();
      clearTimeout(callingTimer);
  };
  }, []);


  const endCall = async () => {
    clearTimeout(callingTimer);
    SDK.endCall();
    endCallAction();
    dispatchDisconnected();
    resetCallData();
    stopAudio();
    callLogs.update(callConnectionDate.data.roomId, {
        "endTime": callLogs.initTime(),
        "callState":0,
        "sessionStatus": CALL_SESSION_STATUS_CLOSED
    });
    setTimeout(() => {
      encryptAndStoreInLocalStorage("callingComponent", false);
      deleteItemFromLocalStorage("roomName");
      deleteItemFromLocalStorage("callType");
      deleteItemFromLocalStorage("call_connection_status");
      encryptAndStoreInLocalStorage("hideCallScreen", false);
      store.dispatch(
        addShowConfrenceData({
          showComponent: false,
          showCalleComponent: false,
          stopSound: true,
          callStatusText: null,
        })
      );
    }, DISCONNECTED_SCREEN_DURATION);
    if(!rosterData){
      return;
    }
  };

  const attendCall = async () => {
    if (preventMultipleClick) {
      return;
    }
    preventMultipleClick = true;
    stopAudio();
    clearTimeout(callingTimer);
    clearMissedCallNotificationTimer();
    if (callConnectionDate && callConnectionDate.data) {
      let call = {};
      call = await SDK.answerCall();
      console.log("attend call", call);
      if (call.statusCode !== 200) {
        if (call.message !== PERMISSION_DENIED) {
          toast.error(COMMON_ERROR_MESSAGE);
        }
        deleteItemFromLocalStorage("roomName");
        deleteItemFromLocalStorage("callType");
        deleteItemFromLocalStorage("call_connection_status");
        encryptAndStoreInLocalStorage("hideCallScreen", false);
        encryptAndStoreInLocalStorage("callingComponent", false);
        encryptAndStoreInLocalStorage("hideCallScreen", false);
        store.dispatch(
          addShowConfrenceData({
            showComponent: false,
            showCalleComponent: false,
            stopSound: true,
            callStatusText: null,
          })
        );
      } else {
        encryptAndStoreInLocalStorage("connecting", true);
        store.dispatch(
          addShowConfrenceData({
            showComponent: true,
            showCalleComponent: false,
          })
        );
        callLogs.update(callConnectionDate.data.roomId, {
            "startTime": callLogs.initTime(),
            "callState": 2
        });
      }
    }
  };
  const declineCall = async () => {
    clearTimeout(callingTimer);
    clearMissedCallNotificationTimer();
    stopAudio();
    endCallAction();
    if (callConnectionDate && callConnectionDate.data) {
      let call = await SDK.declineCall();
      if (call.statusCode === 200) {
        callLogs.update(callConnectionDate.data.roomId, {
            "endTime": callLogs.initTime(),
            "sessionStatus": CALL_SESSION_STATUS_CLOSED
        });
        dispatchDisconnected();
        setTimeout(() => {
          deleteItemFromLocalStorage("roomName");
          deleteItemFromLocalStorage("callType");
          deleteItemFromLocalStorage("call_connection_status");
          encryptAndStoreInLocalStorage("hideCallScreen", false);
          store.dispatch(
            addShowConfrenceData({
              showComponent: false,
              showCalleComponent: false,
              callStatusText: null,
            })
          );
          resetCallData();
        }, DISCONNECTED_SCREEN_DURATION);
      } else {
        handleHideCallScreen();
        console.log("Error occured ", call.errorMessage);
      }
    }
  };

  const playAudio = () => {
    audio.muted = false;
    const audioPromise = audio.play();
    audio.loop = true;
    if (audioPromise !== undefined) {
      audioPromise
        .then((_) => {
          // autoplay started
        })
        .catch((err) => {
          // catch dom exception
          console.info(err);
        });
    }
  };

  const stopAudio = () => {
    audio.loop = false;
    audio.pause();
    audio.currentTime = 0;
  };

  const handleHideCallScreen = (e) => {
    e.stopPropagation();
    hideCallScreen();
  };

  const getGroupDetails = (groupId) =>{
      let rosterDataGD = {};
      let group = getGroupData(groupId);
      rosterDataGD.displayName = group.groupName;
      rosterDataGD.image = group.groupImage;
      rosterDataGD.thumbImage = group.thumbImage;
      rosterDataGD.jid = group.groupId;
      rosterDataGD.chatType = "groupchat";
      return rosterDataGD;
  }
  const toggleMemberNames = () =>{
    console.log("onclick")
  } 

  const handleIncomingCallAudio = () => {
    setTimeout(() => {
      /**
       * Delay added for playing the sound.
       * While the browser tab is in idle,
       * first we need to do any action in the webage to become as active
       * Then only we can play audio
       */      
      audio.load(audio, "audio");
      props.stopSound ? stopAudio() : playAudio();
    }, 500);
  };

  const checkOneToManyCall = () => {
    let callConnectionInfo = callConnectionDate.data;
    return callConnectionInfo.callMode === "onetomany" && callConnectionInfo.groupId === null;
  };

  if (callConnectionDate && callConnectionDate.data) {
    let user = "";
    callConnectionData = callConnectionDate.data;
    if (callConnectionData.callMode === "onetoone") {
      user = callConnectionData.to;
      rosterDatalocal = getUserDetails(user);
    } else if (callConnectionData.callMode === "onetomany") {
      isGroupCall = true;
      if (
        callConnectionData.groupId !== "" &&
        callConnectionData.groupId !== null &&
        callConnectionData.groupId !== undefined
      ) {
        user = callConnectionData.groupId.includes("@")
          ? callConnectionData.groupId.split("@")[0]
          : callConnectionData.groupId;
        rosterDatalocal = { ...getGroupDetails(user) };
        rosterDatalocal.chatType = "groupchat";
      } else {
        let userList = callConnectionData.userList.split(",");
        rosterDatalocal = getCallDisplayDetailsForOnetoManyCall(userList);
      }
    }
  }

  if (callConnectionDate && callConnectionDate.data) {
    if (
      callConnectionDate.data.callType === "audio" ||
      callConnectionDate.data.callType === "Audio"
    ) {
      callType = "Audio";
    } else if (
      callConnectionDate.data.callType === "video" ||
      callConnectionDate.data.callType === "Video"
    ) {
      callType = "Video";
    }
  }

  const callStatus = handleTernayAvoid(isGroupCall, callType);
  let chatType = rosterDatalocal.chatType;

  /**
   * const iniTail = initialNameHandle(rosterDatalocal, rosterDatalocal.image);
   */  

  return (
    <div className="calling-Popup webcall-calling">
      {!addCustomCall && <div className="optionButton visible">
          <div>
            <span
              title="Back to chat"
              className="BackToChat"
              onClick={handleHideCallScreen}
            >
              <i className="backIcon">
                <span className="toggleAnimation"></span>
                <BackToChatHoc />
              </i>
            </span>
          </div>
        </div>}
      {checkOneToManyCall() &&
         <div className="callDetails">
            <div style={{visibility:"hidden"}} className="logosm">
                <img src={Logo} alt="Logo"/>
            </div>
            <CallerProfileList rosterData={rosterDatalocal} />
            <div className="calleeDetails">
                <span className="callerName">
                    {rosterDatalocal.displayName}
                </span>
                <span className="callingStatus">
                    <span>
                    <span> {callStatus} </span>
                    {props.callStatus && props.callStatus.toLowerCase() !== CALL_STATUS_DISCONNECTED &&
                    <div className="callingAnimation incoming">
                        <span className="dot"></span>
                        <span className="dot"></span>
                        <span className="dot"></span>
                    </div>
                     } 
                    </span>
                </span>
            </div>
            </div>
         }
      {!checkOneToManyCall() &&
        <div className="avatar" id="dominantSpeakerAvatar">
          <div className="calling-animation-wrapper">
            <WebChatProfileImg
              blocked={isUserWhoBlockedMe(rosterDatalocal.userId)}
              // name={iniTail}
              chatType={chatType}
              rostersnap={rosterDatalocal.thumbImage !== "" ? rosterDatalocal.thumbImage : rosterDatalocal.image}
            />
            <div className="ripple-1"></div>
            <div className="ripple-2"></div>
            <div className="ripple-3"></div>
          </div>
          <div className="calleeDetails">
            <div className="calle-info">
              <span className="callerName">{rosterDatalocal.displayName}</span>
              {callConnectionDate.data.callMode === "onetomany" &&
                callConnectionDate.data.groupId && (
                  <span className="memmber-details" onClick={toggleMemberNames}>
                    (
                    {callConnectionData &&
                    callConnectionData.userList &&
                    callConnectionData.userList.split(",").length > 0
                      ? callConnectionData.userList.split(",").length - 1
                      : 0}{" "}
                    {callConnectionData.userList.split(",").length - 1 > 1
                      ? "members"
                      : "member"}
                    )
                  </span>
                )}
            </div>
            <span className="callingStatus">
              <span>
                <span> {callStatus} </span>
                {props.callStatus &&
                  props.callStatus.toLowerCase() !==
                    CALL_STATUS_DISCONNECTED && (
                    <div className="callingAnimation incoming">
                      <span className="dot"></span>
                      <span className="dot"></span>
                      <span className="dot"></span>
                    </div>
                  )}
              </span>
            </span>
          </div>
        </div>
      }
      <div className="button-group-center">
        <span className="attenCall" onClick={attendCall}>
          <i>
            <AttenCallHoc viewBox="0 0 32 32" />
          </i>
        </span>
        <span className="rejectCall" onClick={declineCall}>
          <i>
            <RejectCallHoc viewBox="0 0 32 32" />
          </i>
        </span>
      </div>
    </div>
  );
};

export default CalleScreen;
